import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import apiServices from "./apiservice";
// import { toast } from "react-toastify";
// import { config } from "../constant";

const initialState = {
  isSuccess: "",
  isRegister: false,
  isLoading: false,
  isError: false,
  accessToken: "",
  isVerified: false,
  forgetpass: false,
  newpass: false,
  resendotp: false,
  getprofile: {},
  social: false,
  logout:false
};



export const loginAdmin = createAsyncThunk("userlogin/login", async (user, { rejectWithValue }) => {
  try {
    const response = await apiServices.loginAdminapi(user);
    const { data, verified } = response; // Destructuring the response to get data and verified
    return { data, verified };
  } catch (err) {
    return rejectWithValue(err);
  }
});


export const signUpuser = createAsyncThunk("user/sign", async (user, { rejectWithValue }) => {
  try {
    const response = await apiServices.signUpapi(user);
    const { data, user_id } = response; 
   
    return data; 
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const verifyOtp = createAsyncThunk("otp/verify", async (otp, { rejectWithValue }) => {
  try {

    const response = await apiServices.otpapi(otp); // Send the payload to the API
    const { data } = response;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const Forgetpassword = createAsyncThunk("forget/pass", async (email, { rejectWithValue }) => {
  try {

    const response = await apiServices.ForgetPasswordapi(email); 
    const { data } = response;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const Newpassword = createAsyncThunk("new/pass", async (email, { rejectWithValue }) => {
  try {

    const response = await apiServices.createNewpassword(email); 
    const { data } = response;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const ChangePassword = createAsyncThunk("change/pass", async (email, { rejectWithValue }) => {
  try {

    const response = await apiServices.changePassword(email); 
    const { data } = response;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const ResendOtp = createAsyncThunk("resend/otp", async (userID, { rejectWithValue }) => {
  try {

    const response = await apiServices.Resendotp(userID); 
    const { data } = response;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});


export const Getprofile = createAsyncThunk("get/profile", async (userId, { rejectWithValue }) => {
  try {
    const response = await apiServices.Getprofile(userId)
    const { data } = response;
    return data
  } catch (error) {
    return rejectWithValue (error)
  }
})
export const Updateprofile = createAsyncThunk("update/profile", async (userId, { rejectWithValue }) => {
  try {
    const response = await apiServices.UpdateProfile(userId)
    const { data } = response;
    return data
  } catch (error) {
    return rejectWithValue (error)
  }
})
export const Sociallogin = createAsyncThunk("social/login", async (userId, { rejectWithValue }) => {
  try {
    const response = await apiServices.SocialLogin(userId)
    const { data, verified } = response; // Destructuring the response to get data and verified
    return { data, verified };
  } catch (error) {
    return rejectWithValue (error)
  }
})
export const Logoutapi = createAsyncThunk( "logout/api", async (_, { rejectWithValue }) => { // Corrected: underscore `_` as the first argument for payload
    try {
      const response = await apiServices.Logout();
      const { data } = response;
      return data;
    } catch (error) {
      // Use rejectWithValue from the second argument (thunkAPI)
      return rejectWithValue(error);
    }
  }
);


const authSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    resetLogin: (state) => {
      state.accessToken = "";
      state.isRegister = false;
      state.isSuccess = false
      state.forgetpass = false
      state.newpass = false
      state.isVerified = false
      state.resendotp = false
      state.getprofile = {}
      state.social=false
    }, resetState: () => initialState,
  },

  extraReducers: (builder) => {
    builder
    

      .addCase(loginAdmin.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accessToken = action.payload;
        state.isVerified = action.payload.verified; // Assuming the API returns this
        state.isSuccess = true;
      })
      .addCase(loginAdmin.rejected, (state) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(signUpuser.pending, (state) => {
        state.isLoading = true;
        state.isRegister = false;
      })
      .addCase(signUpuser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isRegister = true;
      })
      .addCase(signUpuser.rejected, (state) => {
        state.isLoading = false;
        state.isRegister = false;
        state.isError = true;
      })
    
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(verifyOtp.fulfilled, (state) => {
        state.isLoading = false;
        state.isVerified = true;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(Forgetpassword.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(Forgetpassword.fulfilled, (state) => {
        state.isLoading = false;
        state.forgetpass = true;
      })
      .addCase(Forgetpassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(Newpassword.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(Newpassword.fulfilled, (state) => {
        state.isLoading = false;
        state.newpass = true;
      })
      .addCase(Newpassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(ChangePassword.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(ChangePassword.fulfilled, (state) => {
        state.isLoading = false;
        state.newpass = true;
      })
      .addCase(ChangePassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(ResendOtp.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(ResendOtp.fulfilled, (state) => {
        state.isLoading = false;
        state.resendotp = true;
      })
      .addCase(ResendOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(Getprofile.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(Getprofile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.getprofile = action.payload;
      })
      .addCase(Getprofile.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(Updateprofile.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(Updateprofile.fulfilled, (state) => {
        state.isLoading = false;
        state.resendotp = true;
      })
      .addCase(Updateprofile.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(Sociallogin.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(Sociallogin.fulfilled, (state,action) => {
        state.isLoading = false;
        state.social = true;
        state.isVerified = action.payload.verified;
        console.log(action.payload.verified)// Set the verification status based on the API response
      })
      .addCase(Sociallogin.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(Logoutapi.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(Logoutapi.fulfilled, (state) => {
        state.isLoading = false;
        state.logout = true;
      })
      .addCase(Logoutapi.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { resetLogin,resetState } = authSlice.actions;
export default authSlice.reducer;
